import { mockups } from '../../data/landingPage';
import DownloadButton from '../DownloadButton/DownloadButton';
import PhoneMockup from '../PhoneMockup/PhoneMockup';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-copy">
        <h1 id="hero-title">A 1-minute reset when everything feels like too much.</h1>
        <p>Simple body-based exercises to help you slow down, calm your nervous system, and feel a little lighter.</p>
        <div className="hero-actions">
          <DownloadButton />
        </div>
      </div>
      <div className="hero-visual" aria-label="RELI app screens">
        <PhoneMockup src={mockups.feeling} alt="RELI feeling selection screen" tilt="tilt-left" />
        <PhoneMockup src={mockups.reset} alt="RELI guided reset screen" tilt="front" />
        <PhoneMockup src={mockups.lighter} alt="RELI completion screen" tilt="tilt-right" />
      </div>
    </section>
  );
}

export default HeroSection;
